// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/firstparty/v4/subscription.proto

/* oxlint-disable */
import { ApiTimestamp } from "../../../../../google/protobuf/timestamp";
import { ApiCurrencyAmount } from "../../../../common/payment";
import { ApiPaymentMethod, apiPaymentMethodFromJSON, apiPaymentMethodToJSON } from "./payment_method";

/** Enum for payment status */
export const ApiPaymentStatus = {
  /** PAYMENT_STATUS_UNSPECIFIED - Payment status Default unspecified value */
  PAYMENT_STATUS_UNSPECIFIED: "PAYMENT_STATUS_UNSPECIFIED",
  /** PAYMENT_STATUS_OPEN - Payment is open */
  PAYMENT_STATUS_OPEN: "PAYMENT_STATUS_OPEN",
  /** PAYMENT_STATUS_PAID - Payment is paid */
  PAYMENT_STATUS_PAID: "PAYMENT_STATUS_PAID",
  /** PAYMENT_STATUS_FAILED - Payment failed */
  PAYMENT_STATUS_FAILED: "PAYMENT_STATUS_FAILED",
  /** PAYMENT_STATUS_EXPIRED - Payment expired */
  PAYMENT_STATUS_EXPIRED: "PAYMENT_STATUS_EXPIRED",
  /** PAYMENT_STATUS_CANCELED - Payment canceled */
  PAYMENT_STATUS_CANCELED: "PAYMENT_STATUS_CANCELED",
} as const;

export type ApiPaymentStatus = typeof ApiPaymentStatus[keyof typeof ApiPaymentStatus];

export namespace ApiPaymentStatus {
  export type PAYMENT_STATUS_UNSPECIFIED = typeof ApiPaymentStatus.PAYMENT_STATUS_UNSPECIFIED;
  export type PAYMENT_STATUS_OPEN = typeof ApiPaymentStatus.PAYMENT_STATUS_OPEN;
  export type PAYMENT_STATUS_PAID = typeof ApiPaymentStatus.PAYMENT_STATUS_PAID;
  export type PAYMENT_STATUS_FAILED = typeof ApiPaymentStatus.PAYMENT_STATUS_FAILED;
  export type PAYMENT_STATUS_EXPIRED = typeof ApiPaymentStatus.PAYMENT_STATUS_EXPIRED;
  export type PAYMENT_STATUS_CANCELED = typeof ApiPaymentStatus.PAYMENT_STATUS_CANCELED;
}

export function apiPaymentStatusFromJSON(object: any): ApiPaymentStatus {
  switch (object) {
    case 0:
    case "PAYMENT_STATUS_UNSPECIFIED":
      return ApiPaymentStatus.PAYMENT_STATUS_UNSPECIFIED;
    case 1:
    case "PAYMENT_STATUS_OPEN":
      return ApiPaymentStatus.PAYMENT_STATUS_OPEN;
    case 2:
    case "PAYMENT_STATUS_PAID":
      return ApiPaymentStatus.PAYMENT_STATUS_PAID;
    case 3:
    case "PAYMENT_STATUS_FAILED":
      return ApiPaymentStatus.PAYMENT_STATUS_FAILED;
    case 4:
    case "PAYMENT_STATUS_EXPIRED":
      return ApiPaymentStatus.PAYMENT_STATUS_EXPIRED;
    case 5:
    case "PAYMENT_STATUS_CANCELED":
      return ApiPaymentStatus.PAYMENT_STATUS_CANCELED;
    default:
      return ApiPaymentStatus.PAYMENT_STATUS_UNSPECIFIED;
  }
}

export function apiPaymentStatusToJSON(object: ApiPaymentStatus): string {
  switch (object) {
    case ApiPaymentStatus.PAYMENT_STATUS_UNSPECIFIED:
      return "PAYMENT_STATUS_UNSPECIFIED";
    case ApiPaymentStatus.PAYMENT_STATUS_OPEN:
      return "PAYMENT_STATUS_OPEN";
    case ApiPaymentStatus.PAYMENT_STATUS_PAID:
      return "PAYMENT_STATUS_PAID";
    case ApiPaymentStatus.PAYMENT_STATUS_FAILED:
      return "PAYMENT_STATUS_FAILED";
    case ApiPaymentStatus.PAYMENT_STATUS_EXPIRED:
      return "PAYMENT_STATUS_EXPIRED";
    case ApiPaymentStatus.PAYMENT_STATUS_CANCELED:
      return "PAYMENT_STATUS_CANCELED";
    default:
      return "PAYMENT_STATUS_UNSPECIFIED";
  }
}

/** Message for subscription subscriber information */
export interface ApiSubscriber {
  /** Subscriber's first name */
  readonly firstName: string;
  /** Subscriber's last name */
  readonly lastName: string;
  /** Subscriber's email address */
  readonly email: string;
}

/** Message for subscription */
export interface ApiSubscription {
  /** Subscription ID */
  readonly id: string;
  /** Subscriber information */
  readonly subscriber:
    | ApiSubscriber
    | null;
  /** Whether the subscription is active */
  readonly active: boolean;
}

/** Message for a payment */
export interface ApiPayment {
  /** Payment ID */
  readonly id: string;
  /** Creation timestamp */
  readonly createdAt:
    | Date
    | null;
  /** Payment status */
  readonly status: ApiPaymentStatus;
  /** Payment method used */
  readonly paymentMethod: ApiPaymentMethod;
  /** Payment amount */
  readonly amount:
    | ApiCurrencyAmount
    | null;
  /** Payment completion timestamp */
  readonly paidAt?: Date | null | undefined;
}

export const ApiSubscriber: MessageFns<ApiSubscriber> = {
  fromJSON(object: any): ApiSubscriber {
    return {
      firstName: isSet(object.first_name) ? globalThis.String(object.first_name) : "",
      lastName: isSet(object.last_name) ? globalThis.String(object.last_name) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
    };
  },

  toJSON(message: ApiSubscriber): unknown {
    const obj: any = {};
    if (message.firstName !== undefined && message.firstName !== null) {
      obj.first_name = message.firstName;
    }
    if (message.lastName !== undefined && message.lastName !== null) {
      obj.last_name = message.lastName;
    }
    if (message.email !== undefined && message.email !== null) {
      obj.email = message.email;
    }
    return obj;
  },
};

export const ApiSubscription: MessageFns<ApiSubscription> = {
  fromJSON(object: any): ApiSubscription {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      subscriber: isSet(object.subscriber) ? ApiSubscriber.fromJSON(object.subscriber) : null,
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
    };
  },

  toJSON(message: ApiSubscription): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.subscriber !== undefined && message.subscriber !== null) {
      obj.subscriber = ApiSubscriber.toJSON(message.subscriber);
    }
    if (message.active !== undefined && message.active !== null) {
      obj.active = message.active;
    }
    return obj;
  },
};

export const ApiPayment: MessageFns<ApiPayment> = {
  fromJSON(object: any): ApiPayment {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.created_at) ? fromJsonTimestamp(object.created_at) : null,
      status: isSet(object.status)
        ? apiPaymentStatusFromJSON(object.status)
        : ApiPaymentStatus.PAYMENT_STATUS_UNSPECIFIED,
      paymentMethod: isSet(object.payment_method)
        ? apiPaymentMethodFromJSON(object.payment_method)
        : ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED,
      amount: isSet(object.amount) ? ApiCurrencyAmount.fromJSON(object.amount) : null,
      paidAt: isSet(object.paid_at) ? fromJsonTimestamp(object.paid_at) : null,
    };
  },

  toJSON(message: ApiPayment): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.createdAt !== undefined && message.createdAt !== null) {
      obj.created_at = message.createdAt.toISOString();
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiPaymentStatusToJSON(message.status);
    }
    if (message.paymentMethod !== undefined && message.paymentMethod !== null) {
      obj.payment_method = apiPaymentMethodToJSON(message.paymentMethod);
    }
    if (message.amount !== undefined && message.amount !== null) {
      obj.amount = ApiCurrencyAmount.toJSON(message.amount);
    }
    if (message.paidAt !== undefined && message.paidAt !== null) {
      obj.paid_at = message.paidAt.toISOString();
    }
    return obj;
  },
};

function fromTimestamp(t: ApiTimestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(ApiTimestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
